import React from 'react';
import styled from 'styled-components';
import { ImpText } from '../..';
import { Breakpoints, MaxWidth, spacing, } from '../../DesignSystem/design-system';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: 24px;
  text-align: center;
  max-width: ${MaxWidth.Content};
`;
const ButtonsContainer = styled.div `
  display: flex;
  flex-direction: ${(props) => (props.alwaysColumn ? 'column' : 'row')};
  gap: ${(props) => (props.alwaysColumn ? spacing.s : spacing.l)};
  justify-content: center;
  align-items: center;

  @media (max-width: ${Breakpoints.Mobile}) {
    flex-direction: column;
    gap: ${spacing.s};
  }
`;
export default function ImpButtonDock({ children, message, alwaysColumn, }) {
    return (React.createElement(Container, null,
        message && (
        // TODO: update with correct color
        React.createElement(ImpText, { typography: 'body3', color: '#5E5D5C' }, message)),
        React.createElement(ButtonsContainer, { alwaysColumn: alwaysColumn }, children)));
}
//# sourceMappingURL=ImpButtonDock.js.map